import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attack",
  "use": "attack-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"attack\"><g fill-rule=\"nonzero\"><path d=\"M13.76 3.98L6.92 7.96.03 3.98 6.87 0zM13.76 4.82l-.02 7.46-6.45 3.75.02-7.46zM6.49 8.61l-.02 7.42L0 12.3l.02-7.43z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id